export const colors = {
  primary: '#92E9DC',
  secondary: '#359193',
  fbBlue: '#3b5998'
}
